"use client";

import { TypeBannerSkeleton } from "@contentful/types";
import { Entry } from "contentful";
import { useSession } from "next-auth/react";
import { LeadCaptureBanner } from "./lead-capture-banner";

interface SessionUser {
  isDesignClient?: boolean;
  isBuildStudioClient?: boolean;
}

interface LeadCaptureBannerWrapperProps {
  contentfulContent: Entry<
    TypeBannerSkeleton,
    "WITHOUT_UNRESOLVABLE_LINKS",
    string
  > | null;
  testMode?: boolean;
}

/**
 * Client-side wrapper for LeadCaptureBanner that checks session
 * to determine if the banner should be shown.
 * Design clients and Build Studio clients should not see lead capture banners.
 */
export function LeadCaptureBannerWrapper({
  contentfulContent,
  testMode,
}: LeadCaptureBannerWrapperProps) {
  const { data: session, status } = useSession();

  if (!testMode) {
    // Don't render anything while session is loading
    if (status === "loading") {
      return null;
    }

    // Don't show banner to design clients or build studio clients
    const user = session?.user as SessionUser | undefined;
    if (user?.isDesignClient || user?.isBuildStudioClient) {
      return null;
    }
  }

  return (
    <LeadCaptureBanner
      contentfulContent={contentfulContent}
      testMode={testMode}
    />
  );
}

export default LeadCaptureBannerWrapper;
